import React from 'react'

const MovieTrailer = ({ videos }) => {
	//loop through the videos and if the type.toLowerCase() === trailer then create a new arr

	const movieTrailers = videos.filter((video) => {
		//if the search bar has data and the images are available, show results
		//only show movie trailers that are not age restricted
		if (video.type.toLowerCase() === 'trailer') {
			return video
		}
	})

	//randomize trailers
	const randomNumber = Math.floor(Math.random() * movieTrailers.length)
	const randomTrailer = movieTrailers[randomNumber]
	const trailerKey = randomTrailer.key

	return (
		<iframe
			className="responsive-iframe"
			src={`https://www.youtube.com/embed/${trailerKey}`}
			// width={1000}
			// height={500}
			title="Movie trailer"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
			// sandbox='allow-scripts allow-modal'
		></iframe>
	)
}

export default MovieTrailer
